module.exports = __webpack_public_path__ + "static/media/6.b907d61e.jpg";